import Shepherd from 'shepherd.js';

function setDemoDone() {
  localStorage.setItem('demoDone', true)
}

document.addEventListener("turbolinks:load", () => {
  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    defaultStepOptions: {
      // scrollTo: true,
      cancelIcon: {
        enabled: true,
        label: 'Close'
      },
      classes: 'custom-step',
      modalOverlayOpeningRadius: 4,
      modalOverlayOpeningPadding: 4,
      popperOptions: {
        modifiers: [{ name: 'offset', options: { offset: [0, 16] } }]
      }
    }
  })

  const startButtons = [
    {
      text: 'Skip',
      classes: 'shepherd-button-skip shepherd-button-plain',
      action: tour.cancel
    },
    {
      text: 'Next',
      classes: 'shepherd-button-main',
      action: tour.next
    }
  ]

  const buttons = [
    {
      text: 'Skip',
      classes: 'shepherd-button-skip shepherd-button-plain',
      action: tour.cancel
    },
    {
      text: 'Prev',
      classes: 'shepherd-button-secondary',
      action: tour.back
    },
    {
      text: 'Next',
      classes: 'shepherd-button-main',
      action: tour.next
    }
  ]

  const finishButtons = [
    {
      text: 'Skip',
      classes: 'shepherd-button-skip shepherd-button-plain',
      action: tour.cancel
    },
    {
      text: 'Prev',
      classes: 'shepherd-button-secondary',
      action: tour.back
    },
    {
      text: 'Finish',
      classes: 'shepherd-button-main',
      action: tour.next
    }
  ]

  tour.addStep({
    id: 'job-title-hint',
    text: 'This is the title of your VideeBop link.',
    attachTo: {
      element: '#job-title',
      on: 'bottom'
    },
    buttons: startButtons,
  })

  tour.addStep({
    id: 'job-link-hint',
    text: "This is your URL to share with applicants. Applicants you share this link with will be able to submit a video of their answers to the questions you've asked.",
    attachTo: {
      element: '#job-link',
      on: 'bottom'
    },
    buttons: buttons
  })

  tour.addStep({
    id: 'edit-job-hint',
    text: "Go here to edit your VideeBop links' title and the questions you want applicants to answer.",
    attachTo: {
      element: '#edit-btn',
      on: 'bottom'
    },
    buttons: buttons
  })

  tour.addStep({
    id: 'applicant-view-hint',
    text: "Go here to view your VideeBop link as an applicant.",
    attachTo: {
      element: '#applicant-view',
      on: 'bottom'
    },
    buttons: buttons
  })

  tour.addStep({
    id: 'live-toggle-hint',
    text: 'Click here to toggle the live status. While the job posting is live, you will be charged $1 per video you receive.',
    attachTo: {
      element: '#live-toggle',
      on: 'bottom'
    },
    buttons: buttons
  })

  tour.addStep({
    id: 'applicants-hint',
    text: "A table with all the applicants. The submitted videos will appear here together with the applicants' details.",
    attachTo: {
      element: '#responsive-table',
      on: 'top',
    },
    buttons: finishButtons
  })


  const demoDone = localStorage.getItem('demoDone')
  if (!demoDone) {
    tour.start()
  }

  tour.on('complete', () => {
    setDemoDone()
  })
  tour.on('cancel', () => {
    setDemoDone()
  })
  tour.on('hide', () => {
    setDemoDone()
  })

  document.getElementById('show-hints').addEventListener('click', (e) => {
    e.preventDefault()
    tour.start()
  })
})
